import { Modal, Button, Form, ModalBody, ModalFooter } from "react-bootstrap";
import { useState } from "react";
import { axiosAuth } from "../../api/axiosConfig";
import { getApiErrorInfo } from "../../api/apiError";
import { ErrorText } from "./ErrorReference";

const ChangePasswordModal = ({ show, handleClose }) => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const handleShowPassword = () => {
    setIsVisible(!isVisible);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    // Password validation regex (ASCII-only specials):
    // - Length 8-20
    // - At least 1 uppercase, 1 lowercase, 1 digit, 1 ASCII punctuation special
    // - Allowed characters: letters, digits, and ASCII punctuation only (no whitespace)
    const passwordRegex =
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!"#$%&'()*+,\-./:;<=>?@[\]\\^_`{|}~])[A-Za-z\d!"#$%&'()*+,\-./:;<=>?@[\]\\^_`{|}~]{8,20}$/;

    if (!passwordRegex.test(newPassword)) {
      setError(
        "Password must be 8-20 characters long, include one uppercase letter, one lowercase letter, one number, and one special character."
      );
      return;
    }

    if (newPassword !== confirmNewPassword) {
      setError("New passwords do not match");
      return;
    }
    setIsSubmitting(true);
    try {
      await axiosAuth.patch("/user/change-password", {
        oldPassword,
        newPassword,
      });
      setSuccess("Password changed successfully");
      setOldPassword("");
      setNewPassword("");
      setConfirmNewPassword("");
    } catch (err) {
      setError(getApiErrorInfo(err, "An error occurred. Please try again."));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Change Password</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <ModalBody>
          {error && (
            <div className='alert alert-danger'>
              <ErrorText error={error} />
            </div>
          )}
          {success && <div className='alert alert-success'>{success}</div>}
          <Form.Group className='mb-3' controlId='oldPassword'>
            <Form.Label>Old Password</Form.Label>
            <Form.Control
              type={isVisible ? "text" : "password"}
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className='mb-3' controlId='newPassword'>
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type={isVisible ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
            />
          </Form.Group>
          <Form.Group className='mb-3' controlId='confirmNewPassword'>
            <Form.Label>Confirm New Password</Form.Label>
            <Form.Control
              type={isVisible ? "text" : "password"}
              value={confirmNewPassword}
              onChange={(e) => setConfirmNewPassword(e.target.value)}
              required
            />
          </Form.Group>
          <div className='d-flex justify-content-between align-items-center'>
            <Form.Check
              type='checkbox'
              label='Show Passwords'
              id='show-password-checkbox'
              onChange={handleShowPassword}
              className='ms-2 w-50'
            />
          </div>
          <div className='d-flex justify-content-between align-items-center'>
            <p className='text-muted mt-2' style={{ fontSize: "0.9rem" }}>
              Password must be 8-20 characters long, include one uppercase
              letter, one lowercase letter, one number, and one special
              character.
            </p>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button variant='secondary' onClick={handleClose}>
            Close
          </Button>
          <Button type='submit' variant='primary' disabled={isSubmitting}>
            {isSubmitting ? "Changing..." : "Change Password"}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;
